import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { VOICE_OPTIONS, CONNECTION_STATES } from '../../constants';
import './Header.css';

export function Header({
  connectionStatus,
  selectedVoice,
  onVoiceChange,
  theme,
  onToggleTheme,
}) {
  const isLive = connectionStatus === CONNECTION_STATES.CONNECTED || connectionStatus === CONNECTION_STATES.TALKING;
  const isConnecting = connectionStatus === CONNECTION_STATES.CONNECTING;

  const getStatusLabel = () => {
    if (connectionStatus === CONNECTION_STATES.TALKING) return 'Speaking';
    if (isLive) return 'Live';
    if (isConnecting) return 'Connecting…';
    return 'Standby';
  };

  const dotClass = isLive ? 'is-live' : isConnecting ? 'is-connecting' : '';

  return (
    <header className="app-header">
      {/* Brand */}
      <div className="header-brand">
        <img src="o7servicesLogo.png" height={"40px"} alt="O7 Services" />
          {/* <div className="brand-text">
            O7 Services
            <small>AI-guided IT training &amp; enterprise support</small>
          </div> */}
      </div>

      {/* Right controls */}
      <div className="header-actions">
        {/* Session status pill */}
        <div className={`status-pill ${isLive ? 'is-live' : ''}`}>
          <span className={`status-dot ${dotClass}`} />
          {getStatusLabel()}
        </div>

        {/* Voice selector pill */}
        <div className="voice-pill">
          <select
            value={selectedVoice}
            onChange={(e) => onVoiceChange(e.target.value)}
            title="Assistant Voice"
          >
            {VOICE_OPTIONS.map((v) => (
              <option key={v.id} value={v.id}>{v.name}</option>
            ))}
          </select>
        </div>

        {/*
       <button
          type="button"
          className="hdr-icon-btn"
          onClick={onToggleTheme}
          title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} Mode`}
        >
          {theme === 'dark'
            ? <FiSun className="theme-icon" />
            : <FiMoon className="theme-icon" />}
        </button>
        */}
      </div>
    </header>
  );
}
